export const getCellClassName = (isWrap: boolean): string => (isWrap ? 'block' : 'block truncate');

/** Numeric cells: right-aligned with fixed-width digits so columns of numbers
 * scan and align cleanly (audit AC4). */
export const getNumericCellClassName = (isWrap: boolean): string =>
  `${getCellClassName(isWrap)} text-right tabular-nums`;
